import { INSPECTION_PAGES } from "@/constants/Inspections";

export const InventoryLinksParams = {
  name: "InventoryLinks",
  params: [
    { title: "Structure Identification", value: "D491-Inv-StructureIdentification-Screen", page: "InventoryOnly" },
    { title: "Structure Composition", value: "D491-Inv-StructureComposition-Screen", page: "InventoryOnly" },
    { title: "Maintenance", value: "D491-Inv-Maintenance-Screen", page: "InventoryOnly" },
    { title: "Features", value: "D491-Inv-Features-Screen", page: "InventoryOnly" },
    { title: "Inspection Planning", value: "D491-Inv-InspectionPlanning-Screen", page: "InventoryOnly" },
    { title: "Preservation Rehab", value: "D491-Inv-PreservationRehab-Screen", page: "InventoryOnly" },
    { title: "APRAS", value: "D491-Inv-APRAS-Screen", page: "InventoryOnly" },
    { title: "Signs & Lights", value: "D491-Inv-SignsLights-Screen", page: INSPECTION_PAGES.SIGNS_AND_LIGHTS },
    { title: "Walls", value: "D491-Inv-Walls-Screen", page: INSPECTION_PAGES.WALLS },
    { title: "Tunnels", value: "D491-Inv-Tunnels-Screen", page: INSPECTION_PAGES.TUNNELS },
  ],
};

export const InspectionLinksParams = {
  name: "InspectionLinks",
  params: [
    { title: "Schedule", value: "D491-Insp-Schedule-Screen", page: INSPECTION_PAGES.SCHEDULE },
    { title: "Load Rating", value: "D491-Insp-Load-Rating-Screen", page: INSPECTION_PAGES.LOAD_RATING },
    { title: "NSTMFatigue", value: "D491-Insp-NSTMFatigue-Screen", page: INSPECTION_PAGES.NSTM_FATIGUE },
    { title: "Ratings", value: "D491-Insp-Ratings-Screen", page: INSPECTION_PAGES.RATINGS },
    { title: "Elements", value: "D491-Insp-Elements-Screen", page: INSPECTION_PAGES.ELEMENTS },
    { title: "Approach", value: "D491-Insp-Approach-Screen", page: INSPECTION_PAGES.APPROACH },
    { title: "Deck", value: "D491-Insp-Deck-Screen", page: INSPECTION_PAGES.DECK },
    { title: "Notes", value: "D491-Insp-Notes-Screen", page: INSPECTION_PAGES.NOTES },
    { title: "Joints", value: "D491-Insp-Joints-Screen", page: INSPECTION_PAGES.JOINTS },
    { title: "Signs & Lights", value: "D491-Insp-SignsLights-Screen", page: INSPECTION_PAGES.SIGNS_AND_LIGHTS },
    { title: "Superstructure", value: "D491-Insp-Superstructure-Screen", page: INSPECTION_PAGES.SUPERSTRUCTURE },
    { title: "Walls", value: "D491-Insp-Walls-Screen", page: INSPECTION_PAGES.WALLS },
    { title: "Bearings", value: "D491-Insp-Bearings-Screen", page: INSPECTION_PAGES.BEARINGS },
    { title: "Tunnels", value: "D491-Insp-Tunnels-Screen", page: INSPECTION_PAGES.TUNNELS },
    { title: "Substructure", value: "D491-Insp-Substructure-Screen", page: INSPECTION_PAGES.SUBSTRUCTURE },
    { title: "Culvert", value: "D491-Insp-Culvert-Screen", page: INSPECTION_PAGES.CULVERT },
    { title: "Waterway", value: "D491-Insp-Waterway-Screen", page: INSPECTION_PAGES.WATERWAY },
  ],
};
